export const CRYPTO_DECIMALS = 3;
export const FIAT_DECIMALS = 2;
